require('./impositionEarlyCancelStep1.scss')

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { List } = require('immutable');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const { DEPOSIT_INTERVENTION_OWNER, DATE_FORMAT_WITH_DASHES } = require('constants/index');

// @helpers
const { getFullName } = require('utilities/personalDataHelper');
const dateHelper = require('utilities/dateHelper');

class ImpositionEarlyCancelStep1 extends React.Component {

    render() {

        const {
            immImpositionEarlyCancellationData,
            immProfile,
            immDeposit,
            impositionId,
        } = this.props;

        let content;

        const clientFullName = getFullName(immProfile);
        const immImposition = immDeposit.getIn(['impositionList','byId', impositionId]);
        const immCancellationData = immImpositionEarlyCancellationData.getIn(['impositionEarlyCancellation', 'methodResult']);
        const immInterveners = immDeposit.getIn(['interveners', 'list']) || List();
        const holders = immInterveners
            .filter(intervener => intervener.get('type') === DEPOSIT_INTERVENTION_OWNER)
            .map(intervener => intervener.get('name'))
            .join(' - ');

        const {
            tasaInteresesAlHaberATASAPL,
            tasaFinalATASAFIN,
            fechaValorDisposicionFECVAL1,
        } = immCancellationData.toJSON();

        const date = dateHelper.formatDate(
            dateHelper.fromArray(fechaValorDisposicionFECVAL1),
            DATE_FORMAT_WITH_DASHES
        );

        const injectedStrings = [
            clientFullName,
            immImposition.get('amount'),
            immImposition.get('currency'),
            impositionId,
            immDeposit.getIn([ 'contract', 'fullContractNumber' ]).trim(),
            holders,
            tasaInteresesAlHaberATASAPL,
            tasaFinalATASAFIN,
            date,
            clientFullName
        ];

        content = (
            <div className="imposition-early-cancel-step1">
                <h4 className="imposition-early-cancel-step1__title wizard-step--vertical__title">
                    <FormattedText value="cancelImposition-confirmationTitle" />
                </h4>
                <div className="imposition-early-cancel-step1__main-content">
                    <div className="imposition-early-cancel-step1__subtitle no-print-out">
                        <FormattedText value="cancelImposition-confirmationSubtitle" />
                    </div>
                    <BlockInfo extraClass="imposition-early-cancel-step1__disclaimer-box">
                        <p className="imposition-early-cancel-step1__disclaimer-text">
                            <FormattedText value="cancelImposition-confirmationText" injectedStrings={injectedStrings} />
                        </p>
                    </BlockInfo>
                </div>
            </div>
        );

        return content;
    }
}

ImpositionEarlyCancelStep1.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immImpositionEarlyCancellationData: PropTypes.object.isRequired,
    immDeposit: PropTypes.object,
    impositionId: PropTypes.string.isRequired,
};

module.exports = ImpositionEarlyCancelStep1;
